module.exports = __webpack_public_path__ + "img/accordion-icon.92d16fc7.svg";